var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-input"},[_c('div',{staticClass:"prefix-icons"},[_c('span',[_c('ColumnSvg')],1),_c('span',{staticClass:"pl-2"},[_c('NumberSvg')],1)]),_c('RichTextBox',_vm._g(_vm._b({ref:_vm.RICH_EDITOR_REFERENCE_NAME},'RichTextBox',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }